import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class SiteSwitcher extends ThemeComponent {
    @Ref() toggle!: HTMLButtonElement;

    init() {

        // Handle toggle
        this.handleToggle();
    }

    handleToggle() {

        // When toggle clicked
        this.$listen(this.toggle, 'click', () => {
            this.classList.toggle('site-switcher--active');
        });

        // When non-site-switcher element clicked
        this.$listen(document.body, 'click', (e) => {
            if (e.target) {
                const clickedElement = e.target as HTMLElement;
                if (!this.contains(clickedElement)) {
                    this.classList.remove('site-switcher--active');
                }
            }
        });
    }
}
